/* Refresh Token Strategy Using Request Interceptor */
import axios from 'axios'

import { getAppRequestHeaders } from '@/utils/appRequestHeaders'
import { buildEmmaRequestHeaders } from '@/utils/buildEmmaRequestHeaders'
import { ensureWafGrant, shouldValidateWafRequest } from '@/utils/wafChallenge'

const isPlainObject = (value) => {
	if (value === null || typeof value !== 'object') return false
	const prototype = Object.getPrototypeOf(value)
	return prototype === Object.prototype || prototype === null
}

/**
 * Preserve undefined JSON fields as null so JSON.stringify does not omit them.
 * Only arrays and plain objects are JSON containers; browser/native objects may
 * expose read-only properties and must be left to Axios' normal serialization.
 */
function cleanJSON(value) {
	if (value === undefined) return null
	if (Array.isArray(value)) return value.map(cleanJSON)
	if (!isPlainObject(value)) return value

	return Object.fromEntries(
		Object.entries(value).map(([key, nestedValue]) => [key, cleanJSON(nestedValue)]),
	)
}

export default () => {
	// Add a axios request interceptor
	axios.interceptors.request.use(
		async (config) => {
			config.headers ??= {}
			Object.assign(config.headers, getAppRequestHeaders(axios.getUri(config)))

			if (shouldValidateWafRequest(config)) {
				// Check the browser before sending a protected request.
				await ensureWafGrant()
			}

			config.headers ??= {}
			Object.assign(config.headers, buildEmmaRequestHeaders())

			// Convert undefined to null so that JSON.stringify can't omit it
			if (['post', 'put', 'patch'].includes(config.method)) {
				config.data = cleanJSON(config.data)
			}

			return config
		},
		function (error) {
			// Do something with request error
			return Promise.reject(error)
		},
	)
}
